module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('section', {
    attrs: {
      "epub:type": "note"
    }
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "ter"
    }
  }), _vm._v(" "), _c('hgroup', [_c('h1', {
    staticClass: "FMH"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_vi",
      "title": "vi"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_vii",
      "title": "vii"
    }
  }, [_c('samp', {
    staticClass: "SANS-MetaBook-Roman-11"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#c_ter"
    }
  }, [_vm._v("A NOTE ON TERMINOLOGY")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "FMTNI"
  }, [_vm._v("The story collection that is the subject of this book goes by different titles. Because my focus is on the new tales and material added by European translators to the original collection, I refer to it primarily by the English title most commonly used for these translations: "), _c('i', [_vm._v("Arabian Nights.")]), _vm._v(" When referring to Arabic versions that preceded the European translations, or to translations into languages such as Urdu, I use "), _c('i', [_vm._v("Thousand and One Nights,")]), _vm._v(" a title that is closer to the original Arabic title, "), _c('i', [_vm._v("Alf Layla wa-Layla.")])]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_vm._v("I refer to the characters by the names that were established in eighteenth-century European translations, such as Aladdin, Ali Baba, and Prince Ahmad, or by the names that appear in recent scholarly editions by Hussain Haddawy and Malcolm Lyons, such as Shahrazad and Shahriyar.")]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_viii",
      "title": "viii"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_ix",
      "title": "ix"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_x",
      "title": "x"
    }
  }, [_vm._v("Arabic words and proper names are transliterated without diacritical marks.")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a08e8c5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/terminology.vue
// module id = 69
// module chunks = 0